import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import { team } from "store/schemas";

import magnifiAPI from "../../services/api/magnifi";

export const getTeamByIds = createAsyncThunk("team/getTeamByIds", async (payload) => {
  try {
    const response = await magnifiAPI.getTeamByIds(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getTeams = createAsyncThunk("team/getTeams", async (payload) => {
  try {
    const response = await magnifiAPI.getTeams(payload);

    return { ...response.data, ...(response.data.success ? normalize(response.data.teams, [team]) : {}) };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllTeams = createAsyncThunk("team/getAllTeams", async (payload) => {
  try {
    const response = await magnifiAPI.getAllTeams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const createTeam = createAsyncThunk("team/createTeam", async (payload) => {
  try {
    const response = await magnifiAPI.createTeam(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const updateTeam = createAsyncThunk("team/updateTeam", async (payload) => {
  try {
    const response = await magnifiAPI.updateTeam(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteTeam = createAsyncThunk("team/deleteTeam", async (payload) => {
  try {
    const response = await magnifiAPI.deleteTeam(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateAddTeamThroughCsv = createAsyncThunk("team/validateAddTeamThroughCsv", async (payload) => {
  try {
    const response = await magnifiAPI.validateAddTeamThroughCsv(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createBulkTeams = createAsyncThunk("team/createBulkTeams", async (payload) => {
  try {
    const response = await magnifiAPI.createBulkTeams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getTournamentTeams = createAsyncThunk("team/getTournamentTeams", async ({ tournamentId }) => {
  try {
    const response = await magnifiAPI.getTournamentTeams({ tournamentId });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const uploadBulkTeamTournament = createAsyncThunk("team/uploadBulkTeamTournament", async (payload) => {
  try {
    const response = await magnifiAPI.uploadBulkTeamTournament(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
